import React, {useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/styles';
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Modal,
  TextField,
  Grid,
  FormControl,
  Typography,
  FormControlLabel,
  Checkbox,
  MenuItem,
  Chip, Select,
} from '@material-ui/core';
import _ from 'lodash';
import axios from 'axios';
import CustomSnackbar from '../../user/shared/CustomSnackbar';
import {Cancel} from '@material-ui/icons';
import { ThousandFormatter} from "../shared/Formatters";
import RegenerateBio from "../shared/Buttons/RegenerateBio";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    maxHeight: '100%',
    overfnameY: 'auto',
    width: '50%',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  actions: {
    justifyContent: 'flex-end'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionTitle: {
    margin: '20px 0',
    fontSize: '20px',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    maxHeight: '200px',
    overflowY: 'auto',
  },
  chip: {
    margin: '2px',
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  logoActionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  logo: {
    width: '100px',
    height: '100px',
  },
}))

const FundedPropertyForm = ({
                              adminUserSession,
                              fundedPropertyId,
                              onClose,
                              open,
                              afterCreateFundedProperty,
                              onDataUpdate,
                              itemIndex,
                              ...props
                            }) => {
  const classes = useStyles();

  const [fundedProperty, setFundedProperty] = useState({
    name: '',
    property_types_ids: [],
    logoPreview: '',
    logo: '',
    square_footage: '',
    class_type: '',
    item_to_merge: null
  })

  const propertyClasses = ["Class A", "Class B", "Class C"]

  const [errorMessage, setErrorMessage] = useState({});
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [regions, setRegions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [fundedData, setFundedData] = useState({open: false, data: [], item_to_merge: {}});

  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [showSnackBar, setShowSnackBar] = useState(false);

  useEffect(() => {
    axios.get(
      `/v1/admin/property_types/fintrx_data`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const {
        property_types: property_types,
        status: responseStatus
      } = response.data;
      setPropertyTypes(property_types);
    })

    axios.get(
      `/v1/admin/regions/fintrx_data`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const {
        regions: regionsData,
        status: responseStatus
      } = response.data;

      setRegions(regionsData);
    })
  }, [])

  useEffect(() => {
    if (fundedPropertyId !== undefined && !_.isEmpty(adminUserSession)) {
      axios.get(
        `/v1/admin/funded_properties/${fundedPropertyId}/edit`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': adminUserSession.email,
            'X-Admin-User-Token': adminUserSession.token
          }
        }
      ).then((response) => {
        const {
          funded_property: fundedPropertyData,
          status: responseStatus
        } = response.data;

        const {
          ...itemData
        } = fundedPropertyData

        setFundedProperty({
          ...itemData,
          logoPreview: itemData.logo_url || '',
          item_to_merge: {}
        });

        handleFetchRegionCountries(fundedPropertyData.region_id);
        handleFetchStates(fundedPropertyData.country_id);
        handleFetchFundedData({name: fundedPropertyData.name}, true)
      }).catch(function (thrown) {
        console.log('error', thrown.message)
      });
    }
  }, [fundedPropertyId])

  const handleFetchRegionCountries = (regionId) => {
    axios.get(
      `/v1/admin/regions/${regionId}/countries`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const {
        countries: countriesData,
        status: responseStatus
      } = response.data;

      setCountries(countriesData);
      setStates([])
    })
  }

  const handleFetchStates = (country_id) => {
    setStates([])
    if (countries.find((item) => item.id === country_id)?.name === 'United States') {
      axios.get(
        `/v1/admin/states/us_states`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': adminUserSession.email,
            'X-Admin-User-Token': adminUserSession.token
          }
        }
      ).then((response) => {
        const {
          us_states: us_states,
          status: responseStatus
        } = response.data;
        setStates(us_states)
      })
    }
  }

  const handleFetchFundedData = (params = {}, initializing = false) => {
    if (fundedPropertyId)
      params = {...params, not_id: fundedPropertyId}

    axios.get(
      '/v1/admin/funded_properties/all_funded_data',
      {
        params: params,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const {funded_data, status: responseStatus} = response.data;

      setFundedData({
        ...fundedData,
        open: initializing ? false : true,
        data: funded_data,
      })

      if (initializing && funded_data.length === 1) {
        handleOnChangeAutocomplete(funded_data[0])
      }
    });
  }

  const handleOpenFundedData = (open) => {
    if (open === true) {
      setFundedData({...fundedData, open: true})
    } else {
      setFundedData({...fundedData, open: false, data: []})
    }
  }

  const handleInputChangeAutocomplete = (event) => {
    event.persist();
    debounceFilterInput(event);
  }

  const debounceFilterInput = _.debounce((event) => {
    handleFetchFundedData({name: event.target.value})
  }, 500)

  const handleOnChangeAutocomplete = (selectedValue) => {
    if (!selectedValue)
      selectedValue = {}

    setFundedData({...fundedData, item_to_merge: selectedValue})
    setFundedProperty(prevState => ({
      ...prevState,
      item_to_merge: selectedValue,
    }));
  }

  const handleCreateFundedProperty = (fundedProperty) => {
    let data = new FormData();
    data.append('funded_property[name]', fundedProperty.name);
    data.append('funded_property[url]', fundedProperty.url || '');
    data.append('funded_property[address]', fundedProperty.address || '');
    data.append('funded_property[state]', fundedProperty.state || '');
    data.append('funded_property[city]', fundedProperty.city || '');
    data.append('funded_property[region_id]', fundedProperty.region_id);
    data.append('funded_property[country_id]', fundedProperty.country_id);
    for (let i = 0; i < fundedProperty.property_types_ids.length; i++) {
      data.append('funded_property[property_types_ids][]', fundedProperty.property_types_ids[i]);
    }
    data.append('funded_property[square_footage]', fundedProperty.square_footage);
    data.append('funded_property[class_type]', fundedProperty.class_type);

    if (fundedProperty.logoPreview != fundedProperty.logo_url) {
      data.append('funded_property[logo]', fundedProperty.logo);
    }

    axios.post(
      `/v1/admin/funded_properties`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        },
      }
    ).then((response) => {
      const {
        data: {
          status,
          message,
          funded_property,
        }
      } = response;

      if (status === 'success') {
        afterCreateFundedProperty(funded_property);
        onClose();
      } else {
        setSnackBarMessage(message);
        setShowSnackBar(true);
        console.log('message', message)
      }
    })
  }

  const handleUpdateFundedProperty = (fundedProperty) => {
    let data = new FormData();
    data.append('funded_property[name]', fundedProperty.name);
    data.append('funded_property[url]', fundedProperty.url || '');
    data.append('funded_property[country_id]', fundedProperty.country_id);
    data.append('funded_property[region_id]', fundedProperty.region_id);
    data.append('funded_property[state]', fundedProperty.state || '');
    data.append('funded_property[city]', fundedProperty.city || '');
    data.append('funded_property[address]', fundedProperty.address || '');
    for (let i = 0; i < fundedProperty.property_types_ids.length; i++) {
      data.append('funded_property[property_types_ids][]', fundedProperty.property_types_ids[i]);
    }
    data.append('funded_property[square_footage]', fundedProperty.square_footage);
    data.append('funded_property[class_type]', fundedProperty.class_type);

    if (fundedProperty.logoPreview != fundedProperty.logo_url) {
      data.append('funded_property[logo]', fundedProperty.logo);
    }

    axios.put(
      `/v1/admin/funded_properties/${fundedPropertyId}`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const {
        status: statusUpdate,
        message,
        funded_property,
      } = response.data;

      if (statusUpdate === 'success') {
        onDataUpdate(funded_property, itemIndex);
      } else {
        setErrorMessage(message);
        setSnackBarMessage(message);
        setShowSnackBar(true);
        console.log('message', message)
      }
    });
  }

  const handleOnChange = (event) => {
    event.persist();

    if (['square_footage'].includes(event.target.name) && event.target.value) {
      event.target.value = event.target.value.replace(/[^0-9.-]+/g,"");
    }

    setFundedProperty(prevState => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  }

  const handleOnChangeRegion = (event) => {
    event.persist();

    handleFetchRegionCountries(event.target.value);

    setFundedProperty(prevState => ({
      ...prevState,
      region_id: event.target.value,
      country_id: undefined,
      state_id: undefined,
      state: undefined,
    }));
  }

  const handleOnChangeCountry = (event) => {
    event.persist();
    console.log("change")
    setFundedProperty(prevState => ({
      ...prevState,
      country_id: event.target.value,
      state_id: undefined,
      state: undefined,
    }));

    handleFetchStates(event.target.value);
  }

  const handleOnChangeState = (event) => {
    event.persist();

    setFundedProperty(prevState => ({
      ...prevState,
      state_id: event.target.value,
      state: states.find(state => state.id === event.target.value)?.name,
    }));
  }


  const handleSubmit = (event) => {
    event.persist();
    event.preventDefault();

    const blankValues = Object.keys(_.pickBy(fundedProperty, (item) => ([null, undefined, ''].includes(item))));

    if (
      !_.isEmpty(_.intersection(blankValues, ['name', 'property_types_ids']))
    ) {
      let message = {};

      blankValues.forEach((value) => {
        message[value] = "Can't be blank!"
      })

      setErrorMessage(message);
    } else if (fundedPropertyId !== undefined) {
      handleUpdateFundedProperty(fundedProperty);
    } else {
      handleCreateFundedProperty(fundedProperty);
    }
  }

  const handleMerge = (event) => {
    event.persist();
    event.preventDefault();

    let data = new FormData();
    data.append("id", fundedPropertyId)
    data.append("merge_from_id", fundedProperty.item_to_merge?.id)

    axios.post(
      `/v1/admin/funded_properties/merge_with/`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const {
        status: status,
        message,
        funded_property,
      } = response.data;

      if (status === 'success') {
        setSnackBarMessage('Items has been merged')
        setShowSnackBar(true);
        setFundedProperty(funded_property)
        onDataUpdate(funded_property, itemIndex, true);
      } else {
        setErrorMessage(message);
        setSnackBarMessage(message);
        setShowSnackBar(true);
        console.log('message', message)
      }
    });
  }

  const handleCloseSnackBar = () => {
    setShowSnackBar(false);
    setSnackBarMessage('');
  }

  const handleRemoveFromMultiple = (event, value, field) => {
    event.persist();

    let newData = [...fundedProperty[field]];

    newData = newData.filter((datumId) => datumId !== value);

    setFundedProperty(prevState => ({
      ...prevState,
      [field]: newData,
    }));
  }

  const handleChangeFileInput = (event) => {
    event.persist();
    setFundedProperty(prevState => ({
      ...prevState,
      logo: event.target.files[0],
      logoPreview: event.target.files[0] ? URL.createObjectURL(event.target.files[0]) : fundedProperty.logoPreview,
    }));
  }

  const onRegenerateAiBio = () => {

    axios.put(
        `/v1/admin/funded_properties/${fundedPropertyId}/regenerate_ai_bio`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': adminUserSession.email,
            'X-Admin-User-Token': adminUserSession.token
          }
        }
    ).then((response) => {
      const {
        status: statusUpdate,
        message,
      } = response.data;

      if (statusUpdate === 'success') {
        alert(message)
      } else {
        setErrorMessage(message);
        setSnackBarMessage(message);
        setShowSnackBar(true);
        console.log('message', message)
      }
    });

  }

  const handleOnClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      onClose();
    }
  }

  return (
    <Modal
      onClose={handleOnClose}
      open={open}
    >
      <Card
        className={classes.root}
      >
        <CardHeader title='Funded Property'/>
        <Divider/>
        <CardContent>
          <Grid container spacing={3}>
            <Grid container xs={3}>
              <span className={classes.logoContainer}>
                <img src={fundedProperty?.logoPreview} className={classes.logo}/>
                <div className={classes.logoActionsContainer}>
                  <input type='file' name='logo' onChange={handleChangeFileInput}/>
                </div>
              </span>
              {
                 fundedPropertyId !== undefined &&
                  <span className={classes.logoContainer}>
                    <RegenerateBio
                        show={adminUserSession.isSuperAdmin || adminUserSession.inHouseResearch}
                        onRegenerate={onRegenerateAiBio}
                    />
                  </span>
              }

            </Grid>

            <Grid container spacing={2} xs={9}>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField
                    label="Name"
                    variant="outlined"
                    name='name'
                    required
                    inputProps={{maxLength: 40}}
                    value={fundedProperty.name || ''}
                    onChange={handleOnChange}
                  />
                  <span>{errorMessage['name']}</span>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField
                    label="Url"
                    variant="outlined"
                    name='url'
                    inputProps={{maxLength: 150}}
                    value={fundedProperty.url || ''}
                    onChange={handleOnChange}
                  />
                  <span>{errorMessage['url']}</span>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField
                    select
                    fullWidth
                    required
                    variant='outlined'
                    value={fundedProperty.region_id || ''}
                    label='Region'
                    name='region_id'
                    onChange={handleOnChangeRegion}
                  >
                    <MenuItem value="">
                      <em>Chose a Region</em>
                    </MenuItem>
                    {
                      regions.map((region, index) => <MenuItem key={`${region.name}-${region.id}`}
                                                               value={region.id}>{region.name}</MenuItem>)
                    }
                  </TextField>
                  <span>{errorMessage['region_id']}</span>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField
                    select
                    fullWidth
                    required
                    variant='outlined'
                    value={fundedProperty.country_id || ''}
                    label='Country'
                    name='country_id'
                    onChange={handleOnChangeCountry}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: '300px',
                          },
                        },
                      }
                    }}
                  >
                    <MenuItem value="">
                      <em>Chose a Country</em>
                    </MenuItem>
                    {
                      countries.map((country, index) => <MenuItem key={`${country.name}-${country.id}`}
                                                                  value={country.id}>{country.name}</MenuItem>)
                    }
                  </TextField>
                  <span>{errorMessage['country_id']}</span>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  {states.length > 0 &&
                    <TextField
                      select
                      fullWidth
                      required
                      variant='outlined'
                      value={fundedProperty.state_id || ''}
                      label='State'
                      name='state_id'
                      onChange={handleOnChangeState}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: '300px',
                            },
                          },
                        }
                      }}
                    >
                      <MenuItem value="">
                        <em>Chose a State</em>
                      </MenuItem>
                      {
                        states.map((state, index) => <MenuItem key={`${state.name}-${state.id}`}
                                                               value={state.id}>{state.name}</MenuItem>)
                      }
                    </TextField>}

                  {states.length === 0 &&
                    <TextField
                      label="State"
                      variant="outlined"
                      name='state'
                      inputProps={{maxLength: 40}}
                      value={fundedProperty.state || ''}
                      onChange={handleOnChange}
                      required
                    />}
                  <span>{errorMessage['state_id']}</span>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField
                    label="City"
                    variant="outlined"
                    name='city'
                    inputProps={{maxLength: 40}}
                    value={fundedProperty.city || ''}
                    onChange={handleOnChange}
                  />
                  <span>{errorMessage['city_id']}</span>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Address"
                    variant="outlined"
                    name='address'
                    inputProps={{maxLength: 40}}
                    value={fundedProperty.address || ''}
                    onChange={handleOnChange}
                  />
                  <span>{errorMessage['address']}</span>
                </FormControl>
              </Grid>

              <Grid
                item

                xs={12}
              >
                <FormControl fullWidth>
                  <TextField
                    select
                    label='Property Types'
                    fullWidth
                    variant='outlined'
                    name='property_types_ids'
                    className={classes.selectMultiple}
                    SelectProps={{
                      multiple: true,
                      value: fundedProperty.property_types_ids || [],
                      onChange: handleOnChange,
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: '300px',
                          },
                        },
                      },
                      renderValue: (selected) => {
                        return (
                          <div className={classes.chips}>
                            {propertyTypes.filter((property_type) => selected.includes(property_type.id)).map((property_type) => (
                              <Chip
                                key={property_type.id}
                                label={property_type.name}
                                className={classes.chip}
                                clickable
                                deleteIcon={
                                  <Cancel
                                    onMouseDown={(event) => event.stopPropagation()}
                                  />
                                }
                                onDelete={(e) => handleRemoveFromMultiple(e, property_type.id, 'property_types_ids')}
                              />
                            ))}
                          </div>
                        )
                      }
                    }}
                  >
                    <MenuItem value="">
                      <em>Chose Property Types</em>
                    </MenuItem>
                    {
                      propertyTypes.map((property_type, index) => <MenuItem
                        key={`${property_type.name}-${property_type.id}`}
                        value={property_type.id}>{property_type.name}</MenuItem>)
                    }
                  </TextField>
                  <span>{errorMessage['property_types_ids']}</span>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField
                    label="Square Footage"
                    variant="outlined"
                    name='square_footage'
                    inputProps={{maxLength: 10}}
                    value={fundedProperty.square_footage || ''}
                    onBlur={handleOnChange}
                    InputLabelProps={{ shrink: fundedProperty.square_footage !== ''}}
                    InputProps={{
                      inputComponent: ThousandFormatter
                    }}
                  />
                  <span>{errorMessage['square_footage']}</span>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField
                    select
                    fullWidth
                    required
                    variant='outlined'
                    value={fundedProperty.class_type}
                    label='Class'
                    name='class_type'
                    onChange={handleOnChange}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: '300px',
                          },
                        },
                      }
                    }}
                  >
                    <MenuItem value="">
                      <em>Chose a Class</em>
                    </MenuItem>
                    {
                      propertyClasses.map((class_type) => <MenuItem key={`${class_type}`}
                                                                    value={class_type}>{class_type}</MenuItem>)
                    }
                  </TextField>
                  <span>{errorMessage['country_id']}</span>
                </FormControl>
              </Grid>

              {fundedPropertyId &&
                <>
                <Grid item xs={9}>
                  <Autocomplete
                    name="funded_data_merge"
                    open={fundedData.open}
                    onOpen={(event) => handleOpenFundedData(true)}
                    onClose={(event) => handleOpenFundedData(false)}
                    onChange={(event, value) => handleOnChangeAutocomplete(value)}
                    getOptionSelected={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name ? `${option.name} (${option.funded_type || 'Company'})` : ''}
                    value={fundedProperty.item_to_merge || {}}
                    options={fundedData.data}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Funded Companies / Properties"
                        variant="outlined"
                        onChange={(event) => handleInputChangeAutocomplete(event)}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Button color="primary" fullWidth={true} variant="contained" onClick={handleMerge} style={{minHeight: '53px'}} disabled={_.isEmpty(fundedProperty.item_to_merge)}>Merge it</Button>
                </Grid>
                </>
              }
            </Grid>
          </Grid>
        </CardContent>
        <Divider/>
        <CardActions>
          <Button onClick={onClose}>Close</Button>
          <Button color="primary" variant="contained" onClick={handleSubmit}>Save</Button>
        </CardActions>

        {
          showSnackBar ?
            <CustomSnackbar
              open={showSnackBar}
              closeHandler={handleCloseSnackBar}
              message={snackBarMessage}
              options={{
                severity: 'success'
              }}
            />
            : null
        }
      </Card>
    </Modal>
  )
}

export default FundedPropertyForm;